import { render, staticRenderFns } from "./SelectElementReactive.vue?vue&type=template&id=856ecddc"
import script from "./SelectElementReactive.vue?vue&type=script&lang=js"
export * from "./SelectElementReactive.vue?vue&type=script&lang=js"
import style0 from "./SelectElementReactive.vue?vue&type=style&index=0&id=856ecddc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports